angular.module('aprima-core-ui').factory('ViewportInfo', ['$document',
    function($document){
        'use strict';

        var doc = $document[0];

        function getWidth(){
            var pageWidth = Math.max(
                Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth),
                Math.max(doc.body.offsetWidth, doc.documentElement.offsetWidth),
                Math.max(doc.body.clientWidth, doc.documentElement.clientWidth));

            return pageWidth;
        }

        function getHeight(){
            var pageHeight = Math.max(
                Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
                Math.max(doc.body.offsetHeight, doc.documentElement.offsetHeight),
                Math.max(doc.body.clientHeight, doc.documentElement.clientHeight));

            return pageHeight;
        }

        return{
            getWidth: getWidth,
            getHeight: getHeight,
            getWindowWidth: function() {
                return window.innerWidth;
            },
            getWindowHeight: function() {
                return window.innerHeight;
            }
        };
    }]);
